import { render, staticRenderFns } from "./DialogFrame.vue?vue&type=template&id=6318ace8"
import script from "./DialogFrame.vue?vue&type=script&lang=js"
export * from "./DialogFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports